"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pointerEvents = exports.opacity = exports.BlanketStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _blanketTheme = require("./blanketTheme");
/* eslint-disable @typescript-eslint/no-explicit-any */

const opacity = p => p.isTinted ? _blanketTheme.blanketTheme.opacity(p.themeMode) : 0;
exports.opacity = opacity;
const pointerEvents = p => p.canClickThrough ? "none" : "initial";
exports.pointerEvents = pointerEvents;
const BlanketStyled = (0, _styled.default)("div")`
    background: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _blanketTheme.blanketTheme.background(themeMode);
}};
    bottom: 0;
    left: 0;
    opacity: ${opacity};
    pointer-events: ${pointerEvents};
    position: fixed;
    right: 0;
    top: 0;
    transition: opacity 220ms;
    z-index: ${_ref2 => {
  let {
    zIndex
  } = _ref2;
  return zIndex;
}};
`;
exports.BlanketStyled = BlanketStyled;
//# sourceMappingURL=BlanketStyled.js.map